import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
import { FormEntry, Field } from './';

export default class Form extends BaseAPIModel {
    fields() {
        return {
            name: {},
            weez_id: { primaryKey: true, readOnly: true }
        };
    }

    static fromJSON(form, language) {
        const form_instance = new this(form);
        form_instance.form_entries = FormEntry.list(form.form_entries, language);
        return form_instance;
    }

    static duplicate(form) {
        /**
         * We have to do this static method to duplicate form because form use toApi in details.js.
         */
        const form_instance = new this(form);
        let entries = form_instance.form_entries.map(e => {
            if (e instanceof FormEntry) {
                return e.toAPI();
            }
            return e;
        });
        // In case of duplicate form + duplicate custom field with option
        // we need to remove id of option so that the backend can create new option with new id
        // otherwise the options are not created
        entries = entries.map(entry => {
            const { form_field } = entry;
            const { question_choices } = form_field;

            if (form_field.field_category === 'custom') {
                form_field.question_choices = question_choices.map(question => {
                    const { weez_id, ...questionWithoutId } = question;
                    return questionWithoutId;
                });
            }

            return entry;
        });
        form_instance.form_entries = entries;
        return form_instance;
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][RateGroup][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/forms`;
    }

    static getFormEntries(fields, usage = 'attendee') {
        return Object.values(
            fields.reduce((acc, item) => {
                let fe = new FormEntry();
                fe.usage = usage;
                fe.required = false;
                fe.form_field = Field.fromJSON(item.form_field);

                acc[item.form_field.weez_id] = fe;
                // do not display fields confirmMail and gdpr checkbox
                ['ws-36', 'ws-50'].forEach(entry => delete acc[entry]);
                return acc;
            }, {})
        );
    }

    static getByRates({ organizationId, rateIds, usage = 'attendee' }) {
        return this.fetcher
            .post(`/ticket/organizations/${organizationId}/orders/rates/form`, {
                data: {
                    rate_ids: rateIds,
                    usage
                }
            })
            .then(data => data);
    }
}
